import {Component, OnInit, Input} from '@angular/core'

@Component({
  selector: 'dmmp-image-logo',
  templateUrl: './image-logo.component.html'
})
export class ImageLogoComponent implements OnInit {
  @Input() data
  constructor() {
  }

  ngOnInit(): void {
  }

}
